import { Component } from 'react';

/**
 * One labelled row of a settings card: title, an optional info bubble carrying the long
 * explanation, the short hint underneath it, then the control across the card's full width.
 *
 * Rows stack instead of putting the title in its own column because every control here wants
 * the whole width -- a description textarea and a chip list both wrap badly in half a card.
 */
class SettingsField extends Component {
    render() {
        const { title, hint, tooltip, tooltipId, children } = this.props;

        return (
            <div className="settings-field">
                <div className="settings-field-title">
                    <span>{title}</span>
                    {!!tooltip && (
                        <i
                            className="icon-info-circle settings-field-info"
                            data-tooltip-id={tooltipId}
                            data-tooltip-content={tooltip}
                        />
                    )}
                </div>
                {!!hint && <div className="settings-field-hint">{hint}</div>}
                <div className="settings-field-control">{children}</div>
            </div>
        );
    }
}

export default SettingsField;
